import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { getTreesloLogoPath } from "../../../../core/branding.model";
import { LandingPageToolbarComponent } from "../../../../shared/landing-page-toolbar/landing-page-toolbar.component";
import { LANDING_1_NAV_LINKS } from "../../landing-1.section-data";
import { scrollToLandingSection } from "../../shared/landing-section-scroll.helper";

@Component({
  selector: "app-landing-1-navbar",
  standalone: true,
  imports: [RouterModule, TranslateModule, LandingPageToolbarComponent],
  templateUrl: "./landing-1-navbar.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1NavbarComponent {
  readonly dashboardUrl = input.required<string>();
  readonly heroLogoSrc = getTreesloLogoPath("large", "dark");
  readonly navLinks = LANDING_1_NAV_LINKS;

  scrollToSection(sectionId: string, event: Event): void {
    scrollToLandingSection(sectionId, event);
  }
}
